/**
 * Configuração injetada pelo app. O domínio não lê `import.meta.env`: quem
 * sabe o ambiente é a casca. Isso mantém o pacote testável fora do Vite.
 */
export interface DomainConfig {
  /** Base da API. Vazio = mesma origem (proxy do Vite em dev, rewrite do Hosting em prod). */
  apiUrl: string;
  /** Prefixo das chaves de storage. Sessões independentes do admin e do mobile (A002). */
  storagePrefix: string;
  /** Onde vivem os portais que o app ainda não tem (A007). */
  legacy: { patientUrl: string | null; adminUrl: string | null };
}

let atual: DomainConfig = {
  apiUrl: '',
  storagePrefix: 'eva_app',
  legacy: { patientUrl: null, adminUrl: null },
};

export function configureDomain(cfg: Partial<DomainConfig>): void {
  atual = { ...atual, ...cfg, legacy: { ...atual.legacy, ...(cfg.legacy ?? {}) } };
}

export function domainConfig(): DomainConfig {
  return atual;
}
